import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './shared/layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { ADMIN_ROUTE_CONSTANTS, AUTH_ROUTES } from '@shared/constants/routes';
import { AuthGuard, NotAuthGuard, TabsGuard } from '@core/guard';

export const routes: Routes = [
  { path: '', redirectTo: `/${ADMIN_ROUTE_CONSTANTS.path}/${ADMIN_ROUTE_CONSTANTS.dashboard.path}`, pathMatch: 'full' },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [NotAuthGuard],
    children: [
      {
        path: AUTH_ROUTES.path,
        loadChildren: () => import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES)
      }
      ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard,TabsGuard],
    children: [
      {
        path: ADMIN_ROUTE_CONSTANTS.path,
        loadChildren: () => import('./pages/admin/admin.routes').then(m => m.ADMIN_ROUTES)
      }
    ]
  },
];
